__turbopack_context__.v({
  "card": "direction-cards-module__wRnBjG__card",
  "component": "direction-cards-module__wRnBjG__component",
  "description": "direction-cards-module__wRnBjG__description",
  "list": "direction-cards-module__wRnBjG__list",
  "payoff": "direction-cards-module__wRnBjG__payoff",
  "switch": "direction-cards-module__wRnBjG__switch",
  "text": "direction-cards-module__wRnBjG__text",
  "title": "direction-cards-module__wRnBjG__title",
});
